module.exports = __webpack_public_path__ + "static/img/anxun91.d1ed052e.png";